import { jsx as _jsx } from "react/jsx-runtime";
import { classes } from "./classes.js";
export function Mono({ children, as = "inline", wrap = false }) {
    const className = classes("wt-mono", wrap && "wt-mono-wrap");
    if (as === "block") {
        return (_jsx("pre", { className: className, children: _jsx("code", { children: children }) }));
    }
    return _jsx("code", { className: className, children: children });
}
/** Lined, tabular figures — every number in a table, meter or stat tile in the design. */
export function Numeric({ children }) {
    return _jsx("span", { className: "wt-numeric", children: children });
}
//# sourceMappingURL=mono.js.map